export enum WidgetType {
  LogoWidget,
  ReportWidget
}
